import axios from "axios";
import { apiVariable } from "./apiVariable";
import { OperationsAvailableTruckDto } from "../interfaces/Operations/operationsAvailableTrucks";

const endpoint = `${apiVariable}/getNoLoadTrucks`;

export const fetchOperationsAvailableTrucks = async (
  token: string | null | undefined,
  date?: string
): Promise<OperationsAvailableTruckDto[]> => {
  if (!token) {
    throw new Error("Missing authentication token");
  }

  const response = await axios.get<OperationsAvailableTruckDto[]>(endpoint, {
    params: { date },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};
